import { supabase } from "@/ajax/clients/supabase";
import { trpcClient } from "@/trpc";
import { Storage } from "@/common/utils/storage";
const REFERRAL_STORAGE_KEY = "referral_data";
const REFERRAL_EXPIRY_DAYS = 14;

export const getReferralFromStorage = async (): Promise<string | null> => {
  const stored = await Storage.getItem(REFERRAL_STORAGE_KEY);
  if (!stored) {
    return null;
  }

  const { code, expiry } = JSON.parse(stored);
  if (new Date().getTime() > expiry) {
    await Storage.removeItem(REFERRAL_STORAGE_KEY);
    return null;
  }

  return code;
};

export const setReferralInStorage = async (code: string) => {
  const expiry =
    new Date().getTime() + REFERRAL_EXPIRY_DAYS * 24 * 60 * 60 * 1000;
  await Storage.setItem(
    REFERRAL_STORAGE_KEY,
    JSON.stringify({
      code,
      expiry,
    }),
  );
};

export const clearReferralFromStorage = async () => {
  await Storage.removeItem(REFERRAL_STORAGE_KEY);
};

export const sendReferralComplete = async () => {
  const referralCode = await getReferralFromStorage();
  if (!referralCode) {
    return;
  }
  await trpcClient.referrals.create.mutate({
    referralCode,
  });
  await clearReferralFromStorage();
};

supabase.auth.onAuthStateChange((event, session) => {
  if (event === "SIGNED_IN" && session) {
    sendReferralComplete();
  }
});
